import { createBwTheme } from "@bw/material";

/** Staff apps use Hanken Grotesk (loaded in index.html); the player app keeps Inter. */
const STAFF_FONT_FAMILY = '"Hanken Grotesk", system-ui, sans-serif';

export function createPlatformTheme() {
  return createBwTheme({
    bw: {
      audience: "platform",
      density: "compact",
      minimumTouchTarget: 44,
    },
    colorSchemes: {
      light: {
        palette: {
          secondary: { main: "#53657d" },
          background: { default: "#f4f6f9" },
          semantic: {
            primary: "#2457a7",
            surface: "#ffffff",
            selected: "#dce8fb",
            onSelected: "#173d79",
            focus: "#004fc4",
          },
        },
      },
      dark: {
        palette: {
          secondary: { main: "#bdc9db" },
          background: { default: "#0f1319" },
          semantic: {
            surface: "#171c24",
            primary: "#a9c7ff",
            onPrimary: "#08234a",
            selected: "#263b5e",
            onSelected: "#d6e3ff",
            focus: "#a9c7ff",
          },
        },
      },
    },
    typography: { fontFamily: STAFF_FONT_FAMILY },
    shape: { borderRadius: 8 },
  });
}
